import type { ReactNode } from 'react';

export const symbol_backpack: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M220-80q-24.75 0-42.37-17.63Q160-115.25 160-140v-510q0-55 34-95.5t86-50.5v-54q0-12.75 8.63-21.38Q297.25-880 310-880h40q12.75 0 21.38 8.62Q380-862.75 380-850v50h200v-50q0-12.75 8.63-21.38Q597.25-880 610-880h40q12.75 0 21.38 8.62Q680-862.75 680-850v54q52 10 86 50.5t34 95.5v510q0 24.75-17.62 42.37Q764.75-80 740-80H220Zm0-60h520v-510q0-38-26-64t-64-26H310q-37.12 0-63.56 26Q220-688 220-650v510Zm400-270v50q0 12.75 8.68 21.37 8.67 8.63 21.5 8.63 12.82 0 21.32-8.63 8.5-8.62 8.5-21.37v-80q0-12.75-8.62-21.38Q662.75-470 650-470H310q-12.75 0-21.37 8.68-8.63 8.67-8.63 21.5 0 12.82 8.63 21.32 8.62 8.5 21.37 8.5h310Zm-140-30Z"
		/>
	</svg>
);
